import AnimateIn from "@/components/AnimateIn";
import WCButton from "@/components/WCButton";

const sections = [
  {
    heading: "WHAT WE ARE",
    body: "WrongConception exists to challenge every wrong conception people were handed before they were old enough to question it. About themselves. About the world around them. About the system they live in. We are not just a clothing brand. We are a perspective. And the clothing is the most visible way we say it out loud every single day.",
    quote: "WE WERE ALL HANDED A VERSION OF THE WORLD BEFORE WE WERE OLD ENOUGH TO QUESTION IT.",
  },
  {
    heading: "WHAT WE BELIEVE",
    body: "We believe the wrong answer is sometimes the most honest one. We believe most people are walking around with someone else's opinion in their head calling it their own. We believe the world looks completely different when you stop accepting the first version of it you were given. That is WrongConception.",
    quote: "QUESTION EVERYTHING. ESPECIALLY THIS.",
  },
  {
    heading: "WHAT WE MAKE",
    body: "We make clothes for people who think for themselves. Not trend chasers. Not followers. Not people who buy what they are told to buy. Every piece we make carries a message. Every drop tells a story. Every collection challenges a conception most people never questioned.",
    quote: "NOT JUST THE CLOTHES. THE QUESTIONING.",
  },
  {
    heading: "HOW WE DROP",
    body: "We do not do seasons. We do not do mass production. We drop when we have something to say. Once it is gone, it may not come back.",
    quote: "EVERY DROP TELLS A STORY. EVERY STORY IS REAL.",
  },
  {
    heading: "WHERE WE ARE GOING",
    body: "WrongConception is more than a clothing brand. It is a series. Every drop is tied to a place, a story or a misconception we want to challenge. Guatemala is Vol. 1. The world is next. We are going everywhere the wrong conception lives. And we are going to correct the record one drop at a time.",
    quote: "THE WORLD IS NEXT.",
  },
];

export default function OurStory() {
  return (
    <div data-testid="our-story-page">
      <section className="bg-black pt-[160px] md:pt-[200px] pb-24 px-6 md:px-12 text-center" data-testid="our-story-hero">
        <AnimateIn variant="fade">
          <h1 className="wc-heading text-white text-4xl sm:text-6xl md:text-8xl tracking-widest">
            WRONGCONCEPTION
          </h1>
        </AnimateIn>
        <AnimateIn variant="fade" delay={200}>
          <p className="text-white/75 text-base md:text-lg mt-8 max-w-2xl mx-auto">
            The wrong conception is everywhere. This is what we are doing about it.
          </p>
        </AnimateIn>
      </section>

      {sections.map((s, i) => (
        <section
          key={s.heading}
          className={`${i % 2 === 1 ? "bg-[#0a0a0a]" : "bg-black"} px-6 md:px-12 py-28 border-t border-white/10`}
          data-testid={`our-story-${i + 1}`}
        >
          <div className="max-w-4xl mx-auto">
            <AnimateIn variant="fade">
              <h2 className="wc-heading text-white text-4xl md:text-6xl tracking-widest">
                {s.heading}
              </h2>
            </AnimateIn>
            <AnimateIn variant="fade" delay={150}>
              <p className="text-white/75 text-base md:text-lg mt-10 leading-[1.9]">{s.body}</p>
            </AnimateIn>
            <AnimateIn variant="fade" delay={300}>
              <blockquote className="wc-heading text-white text-3xl md:text-5xl tracking-widest mt-14 border-l-2 border-white pl-6 md:pl-10 leading-tight">
                {s.quote}
              </blockquote>
            </AnimateIn>
          </div>
        </section>
      ))}

      <section className="bg-black px-6 md:px-12 py-28 border-t border-white/10 text-center" data-testid="our-story-cta">
        <AnimateIn variant="fade">
          <div className="flex flex-col md:flex-row gap-6 justify-center">
            <WCButton as="link" to="/shop" data-testid="story-cta-shop">
              Shop Now
            </WCButton>
            <WCButton as="link" to="/drops" data-testid="story-cta-waitlist">
              Join The Waitlist
            </WCButton>
          </div>
        </AnimateIn>
      </section>
    </div>
  );
}
